import { size } from 'lodash';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import useIsMobile from 'hooks/use-is-mobile';

import CalendarIcon from './assets/calendar.svg';
import PlayBackButton from './components/PlayBackButton';
import Slider from './components/Slider';
import { ITEMS } from './constants';
import useStyles from './styles';

interface Props {
    href?: string;
    className?: string;
}

const PromoBlock: React.FC<Props> = ({ className, href }) => {
    const isMobile = useIsMobile();
    const { classes, cx } = useStyles();

    const [index, setIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(true);

    const toggleIsPlaying = useCallback(() => setIsPlaying((value) => !value), []);
    const handleNextSlide = useCallback(() => setIndex((index) => (index + 1) % size(ITEMS)), []);

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.main}>
                {ITEMS.map((item, i) => (
                    <div key={i} className={cx(classes.content, { [classes.visible]: index === i })}>
                        <p className={classes.caption}>{item.caption}</p>
                        <p className={classes.title}>{item.title}</p>
                        <p className={classes.description}>{item.description}</p>
                    </div>
                ))}
                <div className={classes.actions}>
                    <Button
                        disableElevation
                        disableFocusRipple
                        centerRipple
                        fullWidth={isMobile}
                        size="medium"
                        startIcon={<CalendarIcon />}
                        {...(href
                            ? { href, rel: 'nofollow noopener noreferrer', target: '_blank' }
                            : { component: Link, to: '/contacts' })}
                        className={classes.button}
                    >
                        {'Book a live demo'}
                    </Button>
                </div>
            </div>
            <div className={classes.control}>
                <PlayBackButton state={isPlaying ? 'playing' : 'paused'} onClick={toggleIsPlaying} />
                <Slider
                    count={size(ITEMS)}
                    index={index}
                    enabled={isPlaying}
                    orientation={isMobile ? 'horizontal' : 'vertical'}
                    onSlide={handleNextSlide}
                    onClick={setIndex}
                />
            </div>
        </div>
    );
};

export default PromoBlock;
